export default __webpack_public_path__ + "static/media/unsere_haeuser_web-sm@1x.daf972cd.jpg";